import { TaggingFeedActionType } from '@tagging/actions/taggingFeedActions';
import { PRODUCT_ERROR_FILTER_VALUE, TAGGING_FEED_ACTION_TYPES } from '@tagging/constants/taggingConstants';
import { ITaggingFeedState, TaggingFeedType } from '@tagging/models/taggingModels';

const initialState: ITaggingFeedState = {
  feed: [],
  totalFeedItemCount: 0,
  taggingFeedType: TaggingFeedType.Published,
  isFetchingFeed: false,
  currentPageNumber: 0,
  gridLayoutValue: 'grid',
  feedCounts: {
    [TaggingFeedType.Published]: undefined,
    [TaggingFeedType.NeedsProducts]: undefined,
    [TaggingFeedType.ReadyToPublish]: undefined,
    [TaggingFeedType.ReadyToPublishTaggingServices]: undefined,
    [TaggingFeedType.Trash]: undefined,
    [TaggingFeedType.NeedsReview]: undefined,
  },
  isFetchingFeedCounts: false,
  isPublishAllModalOpen: false,
  lastPublishedItemCount: 0,
  isPublishingItems: false,
  isRemovingItems: false,
  isItemDetailsModalOpen: false,
  isGeneratingFeed: false,
  isFetchingInitialFeedGenerationStatus: false,
  productErrorFilterValue: PRODUCT_ERROR_FILTER_VALUE.ALL,
  searchTextValue: undefined,
};

export default function TaggingFeedReducer(
  state: ITaggingFeedState = initialState,
  action: TaggingFeedActionType,
): ITaggingFeedState {
  switch (action.type) {
    case TAGGING_FEED_ACTION_TYPES.REQUEST_FEED: {
      return {
        ...state,
        isFetchingFeed: true,
        taggingFeedType: action.feedType,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.RECEIVE_FEED_SUCCEEDED: {
      return {
        ...state,
        feed: action.feed,
        totalFeedItemCount: action.totalCount,
        isFetchingFeed: false,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.RECEIVE_FEED_FAILED: {
      return {
        ...state,
        isFetchingFeed: false,
        feed: [],
      };
    }
    case TAGGING_FEED_ACTION_TYPES.REQUEST_FEED_COUNTS: {
      return {
        ...state,
        isFetchingFeedCounts: true,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.RECEIVE_FEED_COUNTS_SUCCEEDED: {
      return {
        ...state,
        feedCounts: action.feedCounts,
        isFetchingFeedCounts: false,

      };
    }
    case TAGGING_FEED_ACTION_TYPES.RECEIVE_FEED_COUNTS_FAILED: {
      return {
        ...state,
        isFetchingFeedCounts: false,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.SET_GRID_LAYOUT_VALUE: {
      return {
        ...state,
        gridLayoutValue: action.layout,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.OPEN_PUBLISH_ALL_MODAL: {
      return {
        ...state,
        isPublishAllModalOpen: true,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.CLOSE_PUBLISH_ALL_MODAL: {
      return {
        ...state,
        isPublishAllModalOpen: false,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.OPEN_ITEM_DETAILS_MODAL: {
      return {
        ...state,
        isItemDetailsModalOpen: true,
        itemDetailsModalSelectedItem: action.item,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.CLOSE_ITEM_DETAILS_MODAL: {
      return {
        ...state,
        isItemDetailsModalOpen: false,
        itemDetailsModalSelectedItem: null,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.UPDATE_PAGE_NUMBER: {
      return {
        ...state,
        currentPageNumber: action.pageNumber
      };
    }
    case TAGGING_FEED_ACTION_TYPES.PUBLISH_ALL_ITEMS: {
      return {
        ...state,
        isPublishingItems: true,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.PUBLISH_ALL_ITEMS_SUCCEEDED: {
      return {
        ...state,
        isPublishingItems: false,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.PUBLISH_ALL_ITEMS_FAILED: {
      return {
        ...state,
        isPublishingItems: false,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.PUBLISH_ITEMS: {
      return {
        ...state,
        isPublishingItems: true,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.PUBLISH_ITEMS_SUCCEEDED: {
      return {
        ...state,
        lastPublishedItemCount: action.publishedItemsCount,
        isPublishingItems: false,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.PUBLISH_ITEMS_FAILED: {
      return {
        ...state,
        isPublishingItems: false,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.REMOVE_ITEMS: {
      return {
        ...state,
        isRemovingItems: true,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.REMOVE_ITEMS_SUCCEEDED: {
      return {
        ...state,
        isRemovingItems: false,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.REMOVE_ITEMS_FAILED: {
      return {
        ...state,
        isRemovingItems: false,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.FORCE_UPDATE_ITEMS: {
      return {
        ...state,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.FORCE_UPDATE_ITEMS_FINISHED: {
      return {
        ...state,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.SET_FEED_GENERATION_STATE: {
      return {
        ...state,
        isGeneratingFeed: action.isGeneratingFeed,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.SET_FEED_GENERATION_LOOKUP_STATUS: {
      return {
        ...state,
        isFetchingInitialFeedGenerationStatus: action.isFetchingInitialFeedGenerationStatus,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.SET_ITEM_DETAILS_MODAL_SELECTED_ITEM: {
      return {
        ...state,
        itemDetailsModalSelectedItem: action.item,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.SET_PRODUCT_ERROR_FILTER_VALUE: {
      return {
        ...state,
        productErrorFilterValue: action.productErrorFilterValue,
      };
    }
    case TAGGING_FEED_ACTION_TYPES.SET_SEARCH_TEXT_VALUE: {
      return {
        ...state,
        searchTextValue: action.searchTextValue,
      };
    }
    default:
      return state;
  }
}
